import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  Modal,
  Form,
  // Input,
  Select,
  Button,
  Alert,
  Tooltip,
  Row,
  Col,
  message,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { createUser, createAdmin } from '../../api/user-api';
import PropTypes from 'prop-types';
import {
  roles,
  userRoleTranslations,
  userTypeTranslations,
} from '../../constants/user-constants';
import styles from '../../styles/users.module.scss';
import Input from '../elements/input/Input';
import { toast } from 'react-toastify';

const CreateUserModal = ({ isOpen, onClose, onCreate }) => {
  // const [form] = Form.useForm();
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const [modalForm, setModalForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
  });
  const typeValue = Form.useWatch('type', form);
  const roleValue = Form.useWatch('role', form);

  useEffect(() => {
    if (roleValue === 'admin' || roleValue === 'manager') {
      form.setFieldsValue({ type: 'individual' });
    }
  }, [roleValue, form]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    console.log('Input change:', name, value);

    setModalForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateInputs = () => {
    const { firstName, lastName, email, phone, password } = modalForm;
    if (!firstName.trim()) {
      setError('Unesite ime admina.');
      return false;
    }
    if (!lastName.trim()) {
      setError('Unesite prezime admina.');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Unesite validnu adresu e-pošte.');
      return false;
    }
    if (!phone.trim()) {
      setError('Unesite broj telefona admina.');
      return false;
    }
    // password to contain at least one uppercase, one lowercase, one number and one special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%_.,#+])[A-Za-z\d!$%_.,#+]{8,}$/;
    if (!passwordRegex.test(password)) {
      setError(
        'Lozinka mora sadržati najmanje 8 karaktera, uključujući veliko i malo slovo, broj i specijalni karakter (!$%_.,#+).'
      );
      return false;
    }
    setError('');
    return true;
  };

  const handleOk = async () => {
    setLoading(true);
    setError(null);

    try {
      const isValid = validateInputs();
      if (!isValid) {
        setLoading(false);
        return;
      }
      toast.loading('Kreiranje admina...');
      const values = { ...modalForm };

      const { success, message } = await createAdmin(values);

      if (!success) {
        setError(message);
        toast.dismiss();
        toast.error(message || 'Došlo je do greške pri kreiranju admina.');
        setLoading(false);
        return;
      }

      onCreate();
      onClose();

      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        toast.success('Admin uspešno kreiran.');
        setModalForm({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          password: '',
        });
        setError('');
      }, 1000);
    } catch (error) {
      console.error('Error creating user:', error);
      setError(error.message || 'Došlo je do greške pri kreiranju admina.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setModalForm({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
    });
    setError('');
    setDone(false);
    onClose();
  };

  return (
    <Modal
      className={'create_user_modal'}
      title="Dodaj admina"
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          key="create"
          type="primary"
          onClick={handleOk}
          className="btn-primary"
          disabled={loading}
          style={{ width: '150px' }}
        >
          {loading ? 'Kreiranje...' : 'Kreiraj admina'}
        </Button>,
      ]}
    >
      <form
        className={'create_user_modal_form'}
        layout="vertical"
        autoComplete="off"
        ref={form}
      >
        <Row className={'create_user_modal_row'}>
          <div>
            <Input
              label="Ime"
              id="firstName"
              name="firstName"
              placeholder="Ime"
              value={modalForm.firstName}
              onChange={(e) => handleOnChange(e)}
            />
          </div>

          <div>
            <Input
              label="Prezime"
              id="lastName"
              name="lastName"
              placeholder="Prezime"
              value={modalForm.lastName}
              onChange={(e) => handleOnChange(e)}
            />
          </div>

          <div>
            <Input
              type="email"
              required
              autoComplete="new-email"
              label="Adresa e-poste"
              id="email"
              name="email"
              placeholder="Adresa e-poste"
              value={modalForm.email}
              onChange={(e) => handleOnChange(e)}
            />
          </div>

          <div>
            <Input
                label="Broj telefona"
                id="phone"
                name="phone"
                placeholder="+381657773622"
                value={modalForm.phone}
                onChange={(e) => handleOnChange(e)}
            />
          </div>

          <div>
            <Input
              type="password"
              label="Lozinka"
              id="password"
              name="password"
              placeholder="Lozinka"
              value={modalForm.password}
              onChange={(e) => handleOnChange(e)}
            />
          </div>
        </Row>
        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
      </form>
    </Modal>
  );
};

CreateUserModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default CreateUserModal;
